
// import axios from "axios";

// // 👉 Tự nhận IP của server (LAN hoặc localhost)
// const hostname = window.location.hostname;
// const BASE = `http://${hostname}:8080/api`;

// axios.defaults.headers.post["Content-Type"] = "application/json";

// export const api = {
//   schedules: {
//     list: async () => {
//       const res = await axios.get(`${BASE}/lichlamviec`);
//       return res.data; // JSON thật từ BE
//     },
//     create: async (payload) => {
//       const res = await axios.post(`${BASE}/lichlamviec`, payload);
//       return res.data;
//     },
//     remove: async (id) => {
//       try {
//         await axios.delete(`${BASE}/lichlamviec/${id}`);
//       } catch (err) {
//         if (err.response?.status !== 404) throw err;
//       }
//     },
//   },
// };


import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";

export const api = {
  schedules: {
    list: async () => {
      const res = await axios.get("/api/lichlamviec");
      return res.data;
    },
    create: async (payload) => {
      const res = await axios.post("/api/lichlamviec", payload);
      return res.data;
    },
    remove: async (id) => {
      try {
        await axios.delete(`/api/lichlamviec/${id}`);
      } catch (err) {
        if (err.response?.status !== 404) throw err;
      }
    },
  },
};




